/* SIX PACK — cierre: la barra olímpica en 3D se carga con el scroll.
   Los discos entran por la manga uno a uno (MOVE, FUEL, MIND), el collarín cierra
   y aparece "Make it simple.". Si WebGL no está disponible, el cierre queda con su fondo y su texto. */
import * as THREE from "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js";

(function main() {
  var sec = document.getElementById("cierre");
  if (!sec) return;
  var stick = sec.querySelector(".stick6");
  var host = sec.querySelector("canvas.e3");
  if (!stick || !host) return;
  var isMob = window.innerWidth < 820;

  var renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas: host, antialias: true, alpha: true, powerPreference: "high-performance" });
  } catch (e) { return; }
  if (!renderer.getContext()) return;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMob ? 1.75 : 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.08;
  renderer.setClearColor(0x000000, 0);

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(isMob ? 34 : 28, 1, 0.01, 50);
  (function studio() {
    var s = new THREE.Scene();
    s.add(new THREE.Mesh(new THREE.BoxGeometry(24, 14, 24), new THREE.MeshBasicMaterial({ color: 0x08111d, side: THREE.BackSide })));
    function box(w, h, col, k, p) {
      var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(col).multiplyScalar(k), side: THREE.DoubleSide }));
      m.position.set(p[0], p[1], p[2]); m.lookAt(0, 0, 0); s.add(m);
    }
    box(7, 4.5, 0xfff0dc, 7, [-8, 4, 5]);
    box(1.4, 9, 0xd8e4ff, 5, [8, 1, -4]);
    box(10, 1.6, 0xffffff, 3.2, [0, 9, 0]);
    box(4, 2, 0xc9a36b, 1.6, [2, -5, 7]);
    box(3, 6, 0x9fb4d8, 1.4, [-2, 2, -9]);
    var pm = new THREE.PMREMGenerator(renderer);
    scene.environment = pm.fromScene(s, 0.035).texture;
    pm.dispose();
  })();
  var key = new THREE.DirectionalLight(0xffe7c8, 2.4); key.position.set(-3, 3, 4); scene.add(key);
  var rim = new THREE.DirectionalLight(0xbfd2ff, 1.6); rim.position.set(3, 1.5, -4); scene.add(rim);

  /* ---------- texturas ---------- */
  function knurlTex() {
    var c = document.createElement("canvas"); c.width = c.height = 128;
    var x = c.getContext("2d");
    x.fillStyle = "#c4c4c4"; x.fillRect(0, 0, 128, 128);
    x.strokeStyle = "#3a3a3a"; x.lineWidth = 16; x.filter = "blur(3px)";
    for (var k = -128; k <= 256; k += 64) {
      x.beginPath(); x.moveTo(k, 0); x.lineTo(k + 128, 128); x.stroke();
      x.beginPath(); x.moveTo(k + 128, 0); x.lineTo(k, 128); x.stroke();
    }
    var t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; t.anisotropy = 4;
    return t;
  }
  var sansFamily = (getComputedStyle(document.documentElement).getPropertyValue("--sans") || "").trim() || "system-ui, sans-serif";
  function ringText(text, ink, sizePx) {
    var S = 1024, c = document.createElement("canvas"); c.width = c.height = S;
    var x = c.getContext("2d");
    x.translate(S / 2, S / 2);
    x.fillStyle = ink;
    x.font = "600 " + sizePx + "px " + sansFamily;
    x.textAlign = "center"; x.textBaseline = "middle";
    var R = S * 0.442, chars = text.split(""), total = 0, widths = chars.map(function (ch) { var w = x.measureText(ch).width + sizePx * 0.32; total += w; return w; });
    var ang = -Math.PI / 2 - (total / R) / 2;
    chars.forEach(function (ch, i) {
      var a = ang + widths[i] / 2 / R;
      x.save(); x.rotate(a + Math.PI / 2); x.fillText(ch, 0, -R); x.restore();
      ang += widths[i] / R;
    });
    var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 8;
    return t;
  }

  /* ---------- materiales ---------- */
  var kt = knurlTex();
  var M = {
    chrome: new THREE.MeshPhysicalMaterial({ color: 0xdfe3e8, metalness: 1, roughness: 0.14 }),
    steel: new THREE.MeshPhysicalMaterial({ color: 0xbfc4cb, metalness: 1, roughness: 0.3 }),
    knurl: new THREE.MeshPhysicalMaterial({ color: 0x9ea4ac, metalness: 1, roughness: 0.55, bumpMap: kt, bumpScale: 1.1 }),
    brass: new THREE.MeshPhysicalMaterial({ color: 0xc8a165, metalness: 1, roughness: 0.26 }),
    brassD: new THREE.MeshPhysicalMaterial({ color: 0xa47e47, metalness: 1, roughness: 0.4 }),
    dark: new THREE.MeshPhysicalMaterial({ color: 0x0b0f15, metalness: 0.6, roughness: 0.5 })
  };
  function rubber(hex) {
    return new THREE.MeshPhysicalMaterial({ color: hex, metalness: 0, roughness: 0.58, clearcoat: 0.35, clearcoatRoughness: 0.45, sheen: 0.25, sheenRoughness: 0.6, sheenColor: new THREE.Color(0x8aa0c0) });
  }

  /* ---------- geometría ---------- */
  function arc(pts, cx, cy, r, a0, a1, n) {
    for (var k = 0; k <= n; k++) { var a = a0 + (a1 - a0) * k / n; pts.push(new THREE.Vector2(cx + Math.cos(a) * r, cy + Math.sin(a) * r)); }
  }
  // Disco bumper: perfil de revolución con labio exterior, cara rebajada y bordes redondeados.
  function plateGeo(r, t) {
    var h = t / 2, hr = h * 0.74, ri = 0.09, f = Math.min(0.006, t * 0.12), p = [], V = function (a, b) { p.push(new THREE.Vector2(a, b)); };
    V(ri, -hr);
    V(r * 0.66, -hr);
    arc(p, r * 0.66, -hr + 0.004, 0.004, -Math.PI / 2, -Math.PI / 4, 3);
    V(r * 0.79, -h + 0.002);
    V(r - f, -h);
    arc(p, r - f, -h + f, f, -Math.PI / 2, 0, 6);
    arc(p, r - f, h - f, f, 0, Math.PI / 2, 6);
    V(r * 0.79, h - 0.002);
    arc(p, r * 0.66, hr - 0.004, 0.004, Math.PI / 4, Math.PI / 2, 3);
    V(r * 0.66, hr);
    V(ri, hr);
    V(ri, -hr);
    var g = new THREE.LatheGeometry(p, isMob ? 96 : 144);
    g.rotateZ(-Math.PI / 2);
    return g;
  }
  function lathe(points, seg) {
    var g = new THREE.LatheGeometry(points.map(function (q) { return new THREE.Vector2(q[0], q[1]); }), seg || 64);
    g.rotateZ(-Math.PI / 2);
    return g;
  }
  function cyl(r, len, mat, x) {
    var g = new THREE.CylinderGeometry(r, r, len, 48, 1, true); g.rotateZ(Math.PI / 2);
    var m = new THREE.Mesh(g, mat); m.position.x = x; return m;
  }

  var bar = new THREE.Group(); scene.add(bar);

  // Barra de agarre (28 mm) con moleteado en las zonas reales
  var SH = 0.655;
  bar.add(cyl(0.014, 0.16, M.steel, 0));
  [[0.08, 0.56], [-0.56, -0.08]].forEach(function (z) {
    var len = z[1] - z[0], g = new THREE.CylinderGeometry(0.0141, 0.0141, len, 64, 1, true);
    g.rotateZ(Math.PI / 2);
    var mat = M.knurl.clone();
    var tx = kt.clone(); tx.needsUpdate = true; tx.repeat.set(16, len * 160); mat.bumpMap = tx;
    var m = new THREE.Mesh(g, mat); m.position.x = (z[0] + z[1]) / 2; bar.add(m);
  });
  [[0.56, SH], [-SH, -0.56]].forEach(function (z) { bar.add(cyl(0.014, z[1] - z[0], M.steel, (z[0] + z[1]) / 2)); });

  // Topes, mangas cromadas con ranuras y tapas de latón
  var stopG = lathe([[0.0138, -0.016], [0.031, -0.016], [0.034, -0.012], [0.034, 0.012], [0.031, 0.016], [0.0138, 0.016]], 64);
  var sleevePts = [[0.0, 0.0]], X0 = 0.672, X1 = 1.1;
  (function () {
    sleevePts = [[0.0249, 0]];
    var L = X1 - X0;
    for (var k = 1; k < 7; k++) { var y = L * k / 7; sleevePts.push([0.0249, y - 0.002], [0.0237, y - 0.0008], [0.0237, y + 0.0008], [0.0249, y + 0.002]); }
    sleevePts.push([0.0249, L], [0.0, L]);
  })();
  var sleeveG = lathe(sleevePts, 64);
  var capG = lathe([[0, -0.006], [0.0236, -0.006], [0.0242, -0.003], [0.0242, 0.002], [0.02, 0.006], [0.008, 0.0085], [0, 0.0088]], 48);
  var collarG = lathe([[0.025, -0.022], [0.039, -0.022], [0.042, -0.018], [0.042, -0.012], [0.0395, -0.009], [0.0395, -0.004], [0.042, -0.001], [0.042, 0.004], [0.0395, 0.007], [0.0395, 0.012], [0.042, 0.015], [0.042, 0.019], [0.039, 0.022], [0.025, 0.022]], 64);
  var insertG = lathe([[0.0252, -0.02], [0.093, -0.02], [0.093, 0.02], [0.0252, 0.02], [0.0252, -0.02]], 64);
  var boltG = new THREE.CylinderGeometry(0.0052, 0.0052, 0.003, 6); boltG.rotateZ(Math.PI / 2);
  var ringG = new THREE.TorusGeometry(0.0915, 0.0016, 8, 96); ringG.rotateY(Math.PI / 2);

  var PLATES = [
    { r: 0.225, t: 0.062, col: 0x14253c, ink: "#E9DDC6", txt: "SIX PACK  —  MOVE  —  25 KG  —  THE METHOD  —" },
    { r: 0.19, t: 0.05, col: 0x1b1e23, ink: "#C9A36B", txt: "SIX PACK  —  FUEL  —  15 KG  —  MAKE IT SIMPLE  —" },
    { r: 0.152, t: 0.04, col: 0xe6dccb, ink: "#14253C", txt: "SIX PACK  —  MIND  —  10 KG  —" }
  ];
  var sides = [];
  [1, -1].forEach(function (sd) {
    var s = new THREE.Group(); s.scale.x = sd; bar.add(s);
    var stop = new THREE.Mesh(stopG, M.steel); stop.position.x = SH + 0.016; s.add(stop);
    var sl = new THREE.Mesh(sleeveG, M.chrome); sl.position.x = X0; s.add(sl);
    var cap = new THREE.Mesh(capG, M.brass); cap.position.x = X1 + 0.006; s.add(cap);
    var plates = PLATES.map(function (P, i) {
      var g = new THREE.Group();
      var body = new THREE.Mesh(plateGeo(P.r, P.t), rubber(P.col)); g.add(body);
      var ins = new THREE.Mesh(insertG, M.chrome); ins.scale.x = P.t * 20; g.add(ins);
      [-1, 1].forEach(function (f) {
        var rg = new THREE.Mesh(ringG, M.brass); rg.position.x = f * (P.t * 0.4 + 0.0006); g.add(rg);
        for (var b = 0; b < 6; b++) {   // seis tornillos: el guiño a "six pack"
          var bo = new THREE.Mesh(boltG, M.steel), a = b / 6 * Math.PI * 2;
          bo.position.set(f * (P.t * 0.4 + 0.0015), Math.cos(a) * 0.062, Math.sin(a) * 0.062); g.add(bo);
        }
      });
      var tex = ringText(P.txt, P.ink, P.r > 0.2 ? 30 : P.r > 0.17 ? 34 : 40);
      var dm = new THREE.MeshPhysicalMaterial({ map: tex, transparent: true, metalness: P.ink === "#C9A36B" ? 0.9 : 0.1, roughness: 0.45, side: THREE.DoubleSide, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -2 });
      [-1, 1].forEach(function (f) {
        var d = new THREE.Mesh(new THREE.CircleGeometry(P.r * 1.0, 96), dm);
        d.rotation.y = f > 0 ? Math.PI / 2 : -Math.PI / 2;
        d.position.x = f * (P.t / 2 + 0.0006);
        if (f < 0) d.scale.x = -1;
        g.add(d);
      });
      s.add(g);
      return { g: g, P: P };
    });
    var col = new THREE.Mesh(collarG, M.brass); s.add(col);
    sides.push({ plates: plates, collar: col, sd: sd });
  });

  /* ---------- coreografía: carga de la barra ---------- */
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function seg(p, a, b) { return ease(clamp((p - a) / (b - a), 0, 1)); }
  var V3 = function (a, b, c) { return new THREE.Vector3(a, b, c); };
  var KD = [
    [0.00, V3(2.15, 0.62, 1.25), V3(0.9, -0.02, 0)],
    [0.55, V3(1.75, 0.42, 1.5), V3(0.62, 0, 0)],
    [0.85, V3(1.45, 0.36, 2.95), V3(-0.08, -0.02, 0)],
    [1.00, V3(1.45, 0.36, 2.95), V3(-0.08, -0.02, 0)]
  ];
  var KM = [
    [0.00, V3(2.1, 0.95, 1.05), V3(0.85, -0.12, 0)],
    [0.55, V3(2.3, 0.9, 1.15), V3(0.6, -0.15, 0)],
    [0.85, V3(3.78, 1.77, 2.07), V3(0.2, -0.38, 0)],
    [1.00, V3(3.78, 1.77, 2.07), V3(0.2, -0.38, 0)]
  ];
  var tmpP = new THREE.Vector3(), tmpT = new THREE.Vector3();
  function camAt(p, K) {
    for (var k = 0; k < K.length - 1; k++) {
      if (p <= K[k + 1][0] || k === K.length - 2) {
        var u = ease(clamp((p - K[k][0]) / (K[k + 1][0] - K[k][0]), 0, 1));
        tmpP.lerpVectors(K[k][1], K[k + 1][1], u); tmpT.lerpVectors(K[k][2], K[k + 1][2], u);
        return;
      }
    }
  }
  // Avance: empieza cuando el cierre asoma y termina cuando queda fijo en pantalla
  function progress() {
    var r = sec.getBoundingClientRect(), vh = window.innerHeight, h = r.height - vh;
    return clamp((vh - r.top) / (vh + Math.max(h, 1)), 0, 1);
  }
  var W = 0, H = 0;
  function size() {
    var w = stick.clientWidth, h = stick.clientHeight;
    if (w === W && Math.abs(h - H) < 2) return;
    W = w; H = h; isMob = W < 820;
    renderer.setSize(W, H, false);
    camera.aspect = W / H; camera.fov = isMob ? 34 : 28;
    if (isMob) camera.setViewOffset(W, H, 0, H * 0.06, W, H);
    else camera.setViewOffset(W, H, -W * 0.14, H * 0.24, W, H);
    camera.updateProjectionMatrix();
  }
  window.addEventListener("resize", size);
  window.addEventListener("orientationchange", function () { setTimeout(size, 250); });
  size();

  var onScreen = false;
  if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { rootMargin: "200px 0px" }).observe(sec);
  else onScreen = true;

  host.style.opacity = "1";
  var t0 = performance.now(), sl = sec.querySelector(".huge span");
  function frame(now) {
    requestAnimationFrame(frame);
    if (!onScreen) return;
    var t = (now - t0) / 1000, p = progress();
    // Cada disco entra por la manga, del más grande al más pequeño, y el collarín cierra
    sides.forEach(function (S) {
      var x = X0 + 0.004;
      S.plates.forEach(function (pl, i) {
        var ld = seg(p, 0.12 + i * 0.13, 0.34 + i * 0.13);
        var out = (0.55 + i * 0.22) * (1 - ld);
        pl.g.position.x = x + pl.P.t / 2 + out;
        pl.g.rotation.x = (1 - ld) * (1.2 + i * 0.6);
        x += pl.P.t + 0.003;
      });
      var lk = seg(p, 0.55, 0.68);
      S.collar.position.x = x + 0.024 + (1 - lk) * 0.42;
    });
    bar.rotation.x = t * 0.28;
    camAt(p, isMob ? KM : KD);
    camera.position.copy(tmpP);
    camera.position.y += Math.sin(t * 0.45) * 0.015;
    camera.lookAt(tmpT);
    renderer.render(scene, camera);
    if (sl) sl.style.opacity = (0.25 + 0.75 * seg(p, 0.6, 0.74)).toFixed(3);
  }
  requestAnimationFrame(frame);
})();
